(function () {
	'use strict';

	var userPlatform = avastGlobals.detect.browser.platform,
		oopsModalsTriggerButton = document.querySelectorAll('[data-role="download-link"][data-oops-target][data-platform]');

	for (var i = 0; i < oopsModalsTriggerButton.length; i++) {
		var button = oopsModalsTriggerButton[i];

		// check if oops modal exist
		if (button.getAttribute('data-oops-target') !== '' && document.getElementById(button.getAttribute('data-oops-target'))) {
			button.addEventListener('click', function (e) {
				var downloadPlatform = this.getAttribute('data-platform').toLowerCase(),
					modal = document.querySelector('#' + this.getAttribute('data-oops-target'));

				// check if platforms isn't similar
				if (downloadPlatform !== userPlatform) {
					e.preventDefault();
					e.stopPropagation();
					avastGlobals.web.oopsShow = true;

					var modalButtons = modal.querySelectorAll('[data-role="download-link"]');

					// can be replaced by styles in css
					var styleReset = modal.querySelectorAll('[class*="js-oops-"]');
					for (var x = 0; x < styleReset.length; x++) {
						styleReset[x].style.display = 'none';
					}

					// show title by user's platform
					if (modal.querySelector('.js-oops-title-' + userPlatform)) {
						modal.querySelector('.js-oops-title-' + userPlatform).style.display = 'block';
					}

					// show description by user's and downloaded platforms
					if (modal.querySelector('.js-oops-desc-custom-' + userPlatform)) {
						modal.querySelector('.js-oops-desc-custom-' + userPlatform).style.display = 'block';
					}
					if (modal.querySelector('.js-oops-desc-' + userPlatform + '-' + downloadPlatform)) {
						modal.querySelector('.js-oops-desc-' + userPlatform + '-' + downloadPlatform).style.display = 'block';
					}

					// show primary button by user's platform
					if (modal.querySelector('.js-oops-primary-' + userPlatform)) {
						modal.querySelector('.js-oops-primary-' + userPlatform).style.display = 'block';
					}

					// show secondary button by downloaded platform if 'secondaryDisabled' parameter is not set
					if (!modal.classList.contains('js-oops-disabled-' + userPlatform) && modal.querySelector('.js-oops-secondary-' + downloadPlatform)) {
						modal.querySelector('.js-oops-secondary-' + downloadPlatform).style.display = 'block';
					}

					// show oops modal
					var oopsModal = new BSN.Modal(modal);
					oopsModal.show()

					// tracking of closing modal without download
					modal.addEventListener('hide.bs.modal', function(){
						if (typeof dataLayer !== 'undefined') dataLayer.push({"event": "compatibilityPopupClosed"});
						avastGlobals.web.oopsShow = false;
					},{ once: true });

					// closing modal by clicking download button
					for (var y = 0; y < modalButtons.length; y++) {
						var btn = modalButtons[y];

						btn.addEventListener('click', function() {
							oopsModal.hide();
						})

					}
				}
			});
		}
	};
})();
